export default "__VITE_ASSET__BNjPwzuV__"